import React from 'react';
import './PetAnimations.css';

export default function OcelotSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#D4A843';
  const lightColor = color ? lighten(color) : '#E8C96A';
  const darkColor = color ? darken(color) : '#8B6914';
  const spotColor = '#4A3520';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M88 78C98 72 108 60 106 50C104 42 98 45 96 51C93 59 90 70 85 76"
        stroke={bodyColor}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      {/* Tail spots */}
      <circle cx="100" cy="56" r="2" fill={spotColor} />
      <circle cx="95" cy="65" r="2" fill={spotColor} />
      {/* Body */}
      <ellipse cx="60" cy="76" rx="26" ry="20" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="80" rx="14" ry="12" fill={lightColor} />
      {/* Body spots (rosettes) */}
      <circle cx="45" cy="72" r="3" fill={spotColor} opacity="0.7" />
      <circle cx="55" cy="68" r="2.5" fill={spotColor} opacity="0.7" />
      <circle cx="70" cy="70" r="3" fill={spotColor} opacity="0.7" />
      <circle cx="75" cy="80" r="2.5" fill={spotColor} opacity="0.7" />
      <circle cx="48" cy="82" r="2" fill={spotColor} opacity="0.7" />
      <circle cx="65" cy="82" r="2.5" fill={spotColor} opacity="0.6" />
      {/* Back legs */}
      <ellipse cx="42" cy="90" rx="8" ry="5" fill={bodyColor} />
      <ellipse cx="78" cy="90" rx="8" ry="5" fill={bodyColor} />
      {/* Front paws */}
      <ellipse cx="48" cy="94" rx="5" ry="3.5" fill={darkColor} />
      <ellipse cx="72" cy="94" rx="5" ry="3.5" fill={darkColor} />
      {/* Head */}
      <ellipse cx="60" cy="46" rx="20" ry="18" fill={bodyColor} />
      {/* Head spots */}
      <circle cx="48" cy="38" r="2" fill={spotColor} opacity="0.5" />
      <circle cx="72" cy="38" r="2" fill={spotColor} opacity="0.5" />
      {/* Left ear */}
      <path d="M43 34L37 16L52 28Z" fill={bodyColor} />
      <path d="M44 32L40 20L50 28Z" fill="#E8A0A0" />
      {/* Right ear */}
      <path d="M77 34L83 16L68 28Z" fill={bodyColor} />
      <path d="M76 32L80 20L70 28Z" fill="#E8A0A0" />
      {/* Face */}
      <ellipse cx="60" cy="50" rx="12" ry="9" fill={lightColor} />
      {/* Eyes - green */}
      <ellipse cx="52" cy="43" rx="4" ry="4.5" fill="#A8E6A0" />
      <ellipse cx="68" cy="43" rx="4" ry="4.5" fill="#A8E6A0" />
      {/* Pupils - slit */}
      <ellipse cx="52" cy="43" rx="1.5" ry="3.5" fill="#1A1A1A" />
      <ellipse cx="68" cy="43" rx="1.5" ry="3.5" fill="#1A1A1A" />
      {/* Eye highlights */}
      <circle cx="53.5" cy="41.5" r="1" fill="white" />
      <circle cx="69.5" cy="41.5" r="1" fill="white" />
      {/* Nose */}
      <path d="M58 49L60 51L62 49Z" fill="#E88888" />
      {/* Mouth */}
      <path d="M60 51C60 51 57 53 56 53" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M60 51C60 51 63 53 64 53" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Whiskers */}
      <line x1="38" y1="48" x2="49" y2="49" stroke={darkColor} strokeWidth="0.5" />
      <line x1="38" y1="51" x2="49" y2="51" stroke={darkColor} strokeWidth="0.5" />
      <line x1="38" y1="54" x2="49" y2="52" stroke={darkColor} strokeWidth="0.5" />
      <line x1="82" y1="48" x2="71" y2="49" stroke={darkColor} strokeWidth="0.5" />
      <line x1="82" y1="51" x2="71" y2="51" stroke={darkColor} strokeWidth="0.5" />
      <line x1="82" y1="54" x2="71" y2="52" stroke={darkColor} strokeWidth="0.5" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
